import React from 'react';
import { Icon, Menu } from 'semantic-ui-react';
import './SidenavItem.css';

const SidenavItem = ({ name, icon, children, ...props }) => (
  <Menu.Item name={name} {...props}>
    <div className="sidenav-item-menu-item-text-container">
      <Icon size="large" name={icon || name} />
      <div children={children} className="sidenav-item-menu-item-text" />
    </div>
  </Menu.Item>
);

export default SidenavItem;
